//Build up a custom kendo culture object
//then apply it
import loginProps from "common/managers/loginProps";
import currency from "common/assets/locale/currency";

export default {
    selectFormatting: function(formatting, locale) {
        const culture = $.extend({}, formatting);
        culture.name = "docfinity";

        const cFormat = loginProps.get().currencyFormat;
        if (cFormat && currency[cFormat]) {
            culture.numberFormat.currency = currency[cFormat];
        } else {
            culture.numberFormat.currency = currency["USD"];
        }
        const dateFormat = locale.getDateFormat();
        const dateTimeFormat = locale.getDateTimeFormat();
        if (dateFormat) {
            culture.calendars.standard.patterns.d = dateFormat;
        }
        if (dateTimeFormat) {
            culture.calendars.standard.patterns.g = dateTimeFormat;
        }
        culture.calendars.standard.patterns.D = "dddd, MMMM dd, yyyy";

        kendo.cultures.docfinity = culture;
        kendo.culture("docfinity");
    }
};
